
import { createUseStyles } from "react-jss";
import { colors } from "../../../../styles/colors";
const useStyles = createUseStyles({
  info: {
    display: "flex",
    flexDirection: "column",
    fontSize: 12,
    width: "100%",
    maxWidth: "469px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    borderRadius: "15px",
    padding: "15px",
    gap: "15px",
    "@media (max-width: 1200px)": {
      maxWidth: "100%",
    },
  },
  subContainerInfo: {
    display: "flex",
    gap: "15px",
    flexDirection: "row",
    "@media (max-width:479.95px)": {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  code: {
    width: "182px",
    height: "182px",
    minWidth: "182px",
    backgroundColor: colors.surfaceElevated,
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  description: {
    flex: 1,
    minWidth: 0,
    marginLeft: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width:479.95px)": {
      marginLeft: 0,
      width: "100%",
    },
  },

  paperTitle: {
    paddingBottom: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  mark: {
    fontSize: 12,
    lineHeight: "15px",
    display: "flex",
    gap: "12px",
    "& > div": {
      flex: 1,
      minWidth: 0,
      "& > div": {
        marginBottom: 10,
      },
    },
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      gap: 0,
    },
  },
  subContainerContrat: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    minWidth: 0,
    borderRadius: "10px",
    padding: 10,
    gap: "15px",
    backgroundColor: colors.surfaceElevated,
    "& > div": {
      flex: 1,
      padding: 10,
    },
  },
  contratTitle: {
    color: colors.primary,
  },
  containerContrat: {
    "@media (max-width:899.95px)": { flexDirection: "column" },
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    gap: "13px",
  },
  containerText: {
    padding: "19px 15px 29px 15px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    "& > div": {
      marginBottom: 0,
    },
  },

  divModalText: {
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    "& > div": {
      flex: 1,
      marginBottom: 0,
    },
  },

  divRent: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 25px 0px 25px",
    "& .MuiTypography-root.MuiTypography-body1": {
      fontFamily: "Poppins-Regular",
      fontSize: "13px",
      color: colors.darkblack,
    },
  },
});

export default useStyles;
